/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Permesso } from './permesso';


export interface PermessoUtenteDTO { 
    permesso?: Permesso;
    concesso?: boolean;
}



